import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PlayVideo from "../../Play/custom-video";
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import moment from 'moment'
import Logo from '../../../images/dacha-logo-blue.png';
import _ from 'lodash'
//import ScrollAnimation from "react-animate-on-scroll";
import { LATEST_NEWS_PAGE_URL } from "../../common/site/constants";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";

import Slider from "react-slick";
import "./AllNews.scss"
import { Link } from "@StarberryUtils";

const GET_ALL_NEWS = gql`
  query GetNews{	
    newsItems(sort:"Date:desc", where:{Publish:true})  {
        id
        Title
        Date
        Embed_Video_URL
        Featured
        Meta_Description
        Meta_Title
        URL
        
        Tile_Image {
          alternativeText
          url
        }
        news_category {
          Name
          URL
        }
        imagetransforms
      }
  }
`;


const AllNews = (props) => {

    let [isPlay, setPlay] = React.useState(false);

    const { loading, error, data } = useQuery(GET_ALL_NEWS);

    if (loading) return <div className="gql-loading-screen"><img loading="lazy" src={Logo} alt="Loading - Dacha" /><p>Loading ...</p></div>;

    var NewsList = _.cloneDeep(data.newsItems);
    if (!_.isEmpty(NewsList)) {
        NewsList.map((news) => {
            news['timestamp'] = moment(news.Date).format("X");
        })
        NewsList.sort(function (x, y) {
            return y.timestamp - x.timestamp;
        })
    }
    const featuredNews = NewsList.filter(news => news.Featured === true);
    const newsList = NewsList.filter(news => news.Featured === false);
    return (
        <section class="page-news-wrap sec-pdb-120">
                <Container>
                    <Row className="featured-news-wrap news-list-wrap">
                        {featuredNews && featuredNews.map((news, index, active) => {

                            const image_url = news?.Tile_Image?.url

                            let processedImages = JSON.stringify({});
                            if (news?.imagetransforms?.Tile_Image_Transforms) {
                                processedImages = news.imagetransforms.Tile_Image_Transforms;
                            }

                            return (
                                <div className="col-sm-6 col-lg-4 col-xl-3 news-item featured-news-item">
                                    <div className="news-img-wrapper img-zoom">
                                        <Link to={`${LATEST_NEWS_PAGE_URL.alias}/${news.news_category?.URL}/${news?.URL}`}>
                                            {/* <ImageTransform 
                                            imagesources={image_url} 
                                            renderer="srcSet" 
                                            imagename="news-items.Tile_Image.tile_1" 
                                            attr={{ alt: news.Title + ' - Dacha', class: '' }} 
                                            imagetransformresult={processedImages} 
                                            id={news.id} /> */}
                                             <ImageModule 
                                                ImageSrc={news?.Tile_Image} 
                                                attr={{ alt: news.Title + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_1" 
                                                strapi_id={news?.id} 
                                            />   
                                        </Link>
                                        {news.Embed_Video_URL &&
                                            <div className="banner-btn">
                                                <PlayVideo url={news.Embed_Video_URL}
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className="newsletter-info">
                                        {news.Date &&
                                          <div className="time-info text-xxs">
                                          <span><i class="icon-clock"></i></span><span>{moment(news.Date).format("DD/MM/YYYY")}</span>                                            
                                         </div>
                                        }
                                      
                                        <div className="news-title text-md-bold">
                                            <Link to={`${LATEST_NEWS_PAGE_URL.alias}/${news.news_category?.URL}/${news?.URL}`}>
                                                {news.Title}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Row>
                    <Row className="news-list-wrap">
                        {newsList && newsList.map((news, index, active) => {

                            const image_url = news?.Tile_Image?.url

                            let processedImages = JSON.stringify({});
                            if (news?.imagetransforms?.Tile_Image_Transforms) {
                                processedImages = news.imagetransforms.Tile_Image_Transforms;
                            }

                            return (
                                <div className="col-lg-3 col-md-6 news-item">
                                    <div className="news-img-wrapper img-zoom">
                                        <Link to={`${LATEST_NEWS_PAGE_URL.alias}/${news.news_category?.URL}/${news?.URL}`}>
                                            {/* <ImageTransform imagesources={image_url} renderer="srcSet" imagename="news-items.Tile_Image.tile_2" attr={{ alt: news.Title + ' - Dacha', class: '' }} imagetransformresult={processedImages} id={news.id} /> */}
                                            <ImageModule 
                                                ImageSrc={news?.Tile_Image} 
                                                attr={{ alt: news.Title + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_2" 
                                                strapi_id={news?.id} 
                                            />   
                                        </Link>
                                        {news.Embed_Video_URL &&
                                            <div className="banner-btn">
                                                <PlayVideo url={news.Embed_Video_URL}
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className="newsletter-info">
                                        <div className="time-info text-xxs">
                                            <span><i class="icon-clock"></i></span><span>{moment(news.Date).format("DD/MM/YYYY")}</span>                                            
                                        </div>
                                        <div className="news-title text-md-bold">
                                            <Link to={`${LATEST_NEWS_PAGE_URL.alias}/${news.news_category?.URL}/${news?.URL}`}>
                                                {news.Title}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Row>
                </Container>
        </section>
    )
}
export default AllNews